export default function Library() {
  return (
    <div className="min-h-screen p-8">
      <h1 className="text-4xl font-bold gradient-text">Video Library</h1>
      <p className="mt-4 text-star-white/70">Your videos with hover scrubbing coming soon...</p>
    </div>
  )
}
